export default __webpack_public_path__ + "static/media/Liquid-Cheese2.dbe98325.svg";